import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useBooking } from '../context/BookingContext';
import AssessmentCard from './AssessmentCard';
import './Hero.css';

const Hero = () => {
  const { openCalendly } = useBooking();

  const openDiagnostic = () => {
    const el = document.getElementById('diagnosis');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-bg">
        <div className="aurora aurora-1"></div>
        <div className="aurora aurora-2"></div>
        <div className="aurora aurora-3"></div>
        <div className="hero-noise"></div>
      </div>

      <div className="container hero-container">
        <div className="hero-content">
          <div className="hero-left">
            <div className="hero-label">
              <span className="hero-label-primary">Supercharge your business with AI</span>
              <span className="hero-label-secondary">
                Workflow audits for owner-operated businesses
              </span>
            </div>

            <h1 className="hero-title">
              Your business already<br />
              has demand. Here's<br />
              <span className="gradient-text">what's leaking.</span>
            </h1>

            <p className="hero-description">
              Most businesses don’t lose because of slow sales. They lose time, money, and effort after someone
              reaches out. We recover that with automation and AI where it pays off — not software for its own sake.
            </p>

            <div className="hero-slogan-block">
              <p className="hero-slogan">Recover more with Cure8 Studios.</p>
              <p className="hero-slogan-descriptor">Time. Money. Effort.</p>
            </div>

            <div className="hero-actions">
              <button
                type="button"
                className="btn hero-cta-primary"
                onClick={openCalendly}
              >
                Book an Assessment
              </button>
              <button
                className="btn btn-ghost hero-cta-secondary"
                onClick={() => scrollToSection('how-it-works')}
              >
                See how it works
                <ArrowRight size={15} />
              </button>
            </div>

            <p className="hero-guarantee">
              If we don't find at least 5× the audit fee in leakage, we'll tell you.
            </p>

            <button className="hero-diagnosis-link" onClick={openDiagnostic}>
              Where are leads slipping? Free 2-min check
              <ArrowRight size={13} />
            </button>
          </div>

          <div className="hero-right">
            <div className="hero-visual">
              <AssessmentCard />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
